<section class="py-3">
  <div class="container-fluid card">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <app-main-heading [heading]="'All Dealers'" class="m-0"></app-main-heading>
      <div>
        <button class="btn app-btn-primary" style="height: 38px; display: flex; align-items: center; justify-content: center;" [routerLink]="'/new-dealer'">Add Dealer</button>
      </div>
    </div>
    <div class="card app-table-thick-border shadow-none">
      <div class="table-responsive" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="500" (scrolled)="onScroll()">
        <table class="table app-table-rounded align-middle m-0 w-100">
          <thead>
            <tr class="app-table-header">
              <th scope="col" sortable="">Name</th>
              <th scope="col" sortable="">Code</th>
              <th scope="col" sortable="">Phone</th>
              <th scope="col" sortable="">Address</th>
              <th scope="col" sortable="">Credit Limit</th>
              <th scope="col" sortable="">Credit Duration</th>
              <th scope="col" sortable="">Action</th>
            </tr>
          </thead>
          <tbody>
            @if (dealersList.length > 0) {
              @for (list of dealersList; track list) {
                <tr class="app-td-text app-table-body">
                  <td class="fw-bold td-text-three">{{list.name}}</td>
                  <td class="text-muted td-text-three">{{list.branchCode}}</td>
                  <td class="text-nowrap td-text-three">{{list.phoneNumber}}</td>
                  <td class="td-text-one">{{list.address.line1}},
                    {{list.address.line2}},{{list.address.city}},{{list.address.state}},{{list.address.pincode}}
                  </td>
                  <td class="td-text-two">{{list.creditLimit}}</td>
                  <td class="td-text-two">{{list.delayAfterDelivery}}</td>
                  <td>
                    <fa-icon [icon]="faEdit" (click)="editBranch(list._id)" class="btn app-btn-primary btn-sm"
                    data-bs-toggle="tooltip" ngbTooltip="Edit dealer" [placement]="'top'"></fa-icon>
                    &nbsp;
                  </td>
                </tr>
              }
            }

            @if (loader) {
              <tr>
                <td colspan="7">
                  <div class="custom-col-width-100 d-flex justify-content-center py-5">
                    <app-loader [loadingIcon]="loader"></app-loader>
                  </div>
                </td>
              </tr>
            }

            @if (!loader && dealersList.length === 0) {
              <tr>
                <td colspan="7">
                  <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                    No data Found!
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>



@if (isToster) {
  <app-toaster [title]="message" (closeToaster)="closeToster($event)"></app-toaster>
}